import React from 'react'
import Skills from '../layouts/Skills'
import { about, skillsBar, section2title } from '../../profile'
import progGif from './prog.gif'
import Particles from 'react-particles-js'

console.log()

const About = () => {
    return (
        <div id="about" className="effect2">
              
            
<div data-aos="zoom-in-up" data-aos-once="true" className="row bgzinho">
            <div className="About-title-box">
                <h1 id="About" className="red-line">{section2title}</h1>
                </div>
            <div className="col-12 offset-md-1 col-md-6 about">
                
                <div className="lead about-text">
                   <p>
                     {about.paragraph}  
                       </p>   
                       <p>
                       {about.paragraph2} 
                       </p>
                       <p>
                       {about.paragraph3} 
                       </p>
                </div>
                
            </div>
            <div className="col-12  d-md-block offset-md-1 col-md-4 Photo" id="not"></div>
            
            
            </div>

           

            

            
            <div className="row" id="Skills"> 
            <h1 id='SkillHeader'>Skills</h1>
            <div className='row'>
            {/*  
             <div className="col-6 skills">
                    {skillsBar.map((x) => 
                        <Skills label={x.name} per={x.value}/>
                    )}
                </div>
                        COLOCAR LOTTIE
            */}
            <div className="col-12 col-md-6 gifinho">
                <img src={progGif} alt='programaLouco'></img>
            </div>
           
                <div className="col-12 col-md-6 skills">
                    {skillsBar.map((x) => 
                        <Skills label={x.name} per={x.value}/>
                    )}
                </div>
            </div>
                 
            </div>
        </div>
    )
}

export default About
